import { useTranslations } from 'next-intl'

import { Slot } from '@/shared/lib'
import { Form } from '@/shared/ui'

type Props = {
  placeholder?: string
  readOnly?: boolean
  disabled?: boolean
}

export const HostIntroField = ({
  placeholder,
  readOnly = false,
  disabled = false,
}: Props) => {
  const t = useTranslations('user_information')

  return (
    <Form.Field name="hostIntro" readOnly={readOnly} disabled={disabled}>
      <Form.Label className="font-medium text-black">
        {t('landlord_intro_label')}
      </Form.Label>
      <Form.Textarea
        className="h-32"
        useCount
        maxLength={30}
        readOnly={readOnly}
        placeholder={placeholder || t('landlord_intro_placeholder')}
      >
        <Slot name="message">
          <Form.Message />
        </Slot>
      </Form.Textarea>
    </Form.Field>
  )
}
